import styles from "../assets/css/Delete.module.css";

const DeletePromotion = ({ onClose, onCloseModal }) => {

  return (
    <div className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.box}>
          <div className={styles.text}>Удалить?</div>
          <img
            onClick={() => onCloseModal()}
            className={styles.closeicon}
            src="/images/close.svg"
            alt="close icon"
          />
        </div>
        <div className={styles.text1}>Эта акция будет удалена</div>
        <div className={styles.box1}>
          <button onClick={() => onClose()} className={styles.deletebtn}>
            Удалить
          </button>
          <button onClick={() => onCloseModal()} className={styles.cancelbtn}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePromotion;